// extracted by mini-css-extract-plugin
export default {"draftSavedToast":"YnvVciCA2vYMp_JWc3Ok"};